import getConfig from 'next/config';

const {
  publicRuntimeConfig: { gtmSkipUUID },
} = getConfig();

export const featureFlags = {
  skipGTM: gtmSkipUUID,
  sharing: 'true',
  dateRange: 'true',
};
